var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2364_31450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8201 19.7086L19.7072 25.8214C19.4862 26.0421 19.1867 26.1661 18.8744 26.1661C18.562 26.1661 18.2625 26.0421 18.0415 25.8214L7.81151 15.5914C7.75056 15.5332 7.7034 15.462 7.67349 15.3831C7.64358 15.3043 7.63168 15.2198 7.63866 15.1357L8.5658 9.10143C8.57661 8.96333 8.63637 8.83362 8.73432 8.73567C8.83228 8.63771 8.96198 8.57795 9.10009 8.56714L15.1344 7.64C15.2184 7.63302 15.303 7.64493 15.3818 7.67483C15.4606 7.70474 15.5318 7.7519 15.5901 7.81286L25.8201 18.0429C26.0408 18.2638 26.1648 18.5634 26.1648 18.8757C26.1648 19.188 26.0408 19.4876 25.8201 19.7086V19.7086Z",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.332 11.3329L5.83203 5.83289",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2364_31450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag);
export default __webpack_public_path__ + "static/media/price-tag.3b23286080173955d3ba256de116df37.svg";
export { ForwardRef as ReactComponent };